// extracted by mini-css-extract-plugin
module.exports = {"masthead":"masthead_masthead__l_Ulx","masthead__content":"masthead_masthead__content__QLg31"};